import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import {  H4 } from '@blueprintjs/core';
import {  Paper } from '@material-ui/core';
import Chart from 'react-apexcharts';
import { rounded } from '../../../utils.js'
//import {MAX_CHART_SIZE} from '../../../constants.js';

import './VocAll.css';
//import { ReceiptRounded } from '@material-ui/icons';

class VocComparison extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { 
      currentKey:0 // the current key for the realSpec chart
    };
  }

  computeChartOption=(tab,label)=>{
    let filteredTab={};
    for (var key in tab) {
      if (key !=='__global__') {
        filteredTab[key]=tab[key]
      }
    }
   
    // prep data for the chart

    const series = [{
        name:label,
        data: Object.keys(filteredTab).sort().map( subCorpus => filteredTab[subCorpus]) 
    }];
    const options = {
      chart: {
        type: 'bar',
        height: 350
      },
      plotOptions: {
        bar: {
          //columnWidth: '80%',
        }
      },
      dataLabels: {
        enabled: true,
      },
      yaxis: {
        title: {
          text: label,
        },
        labels: {
          formatter: function (y) {
            return rounded(y,0);
          }
        }
      },
      xaxis: {
        type: 'text',
        categories: Object.keys(filteredTab).sort(),
        labels: {
          rotate: -90
        }
      }
    }
    return [options, series]
  }

  
  render() {
    const { t, nbDocs, nbParas, nbSents, nbCls, vocSize, averageLength, size, lexicalDensity } = this.props;

    //*******************************  nbDocs
    const [nbDocsOptions,nbDocsSeries]=this.computeChartOption(nbDocs,t('docNumber'));
    const nbDocsChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={nbDocsOptions} 
              series={nbDocsSeries} 
              type="bar" 
              height={350} 
      />;


    //*******************************  nbParas
    const [nbParasOptions,nbParasSeries]=this.computeChartOption(nbParas,t('paraNumber'));
    const nbParasChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={nbParasOptions} 
              series={nbParasSeries} 
              type="bar" 
              height={350} 
      />;

      //*******************************  nbSents
    const [nbSentsOptions,nbSentsSeries]=this.computeChartOption(nbSents,t('sentNumber'));
    const nbSentsChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={nbSentsOptions} 
              series={nbSentsSeries} 
              type="bar" 
              height={350} 
      />;


    //*******************************  nbToks
    const [nbToksOptions,nbToksSeries]=this.computeChartOption(size,t('tokenNumber'));
    const nbToksChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={nbToksOptions} 
              series={nbToksSeries} 
              type="bar" 
              height={350} 
      />;

    //*******************************  nbToks
    const [nbClsOptions,nbClsSeries]=this.computeChartOption(nbCls,t('clsNumber'));
    const nbClsChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={nbClsOptions} 
              series={nbClsSeries} 
              type="bar" 
              height={350} 
      />;


    //*******************************  averageWordLength
    const [averageWordLengthOptions,averageWordLengthSeries]=this.computeChartOption(averageLength,t('averageLength'));
    const averageWordLengthChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={averageWordLengthOptions} 
              series={averageWordLengthSeries} 
              type="bar" 
              height={350} 
      />;


    //*******************************  vocSize
    const [vocSizeOptions,vocSizeSeries]=this.computeChartOption(vocSize,t('vocSize'));
    const vocSizeChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={vocSizeOptions} 
              series={vocSizeSeries} 
              type="bar" 
              height={350} 
      />;

    //*******************************  typeToken
    let typeToken={};
    for (var key in nbSents) {
      if (key !=='__global__') {
        typeToken[key]=rounded(vocSize[key]/size[key],3);
      }
    }
    const [typeTokenOptions,typeTokenSeries]=this.computeChartOption(typeToken,t('TTR'));
    const typeTokenChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={typeTokenOptions} 
              series={typeTokenSeries} 
              type="bar" 
              height={350} 
      />;

    //******************************* averageParagraphLength
    let filteredAverageParagraphLength={};
    let noAverageParagraphLengthChart=false;
    for (key in nbParas) {
      if (key !=='__global__') {
        if (nbParas[key]) {
          filteredAverageParagraphLength[key]=rounded(size[key]/nbParas[key],2);
        } else {
          noAverageParagraphLengthChart=true;
        }
        
      }
    }
    const [averageParagraphLengthOptions,averageParagraphLengthSeries]=this.computeChartOption(filteredAverageParagraphLength,t('averageParaLengthToks'));
    const averageParagraphLengthChart= noAverageParagraphLengthChart? "":
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={averageParagraphLengthOptions} 
              series={averageParagraphLengthSeries} 
              type="bar" 
              height={350} 
      />;

    //******************************* averageSentenceLength (cls)
    let filteredAverageSentenceLengthCls={};
    for (key in nbCls) {
      if (key !=='__global__') {
        filteredAverageSentenceLengthCls[key]=rounded(nbCls[key]/nbSents[key],2);
      }
    }
    const [averageSentenceLengthClsOptions,averageSentenceLengthClsSeries]=this.computeChartOption(filteredAverageSentenceLengthCls,t('averageSentLengthCls'));
    const averageSentenceLengthClsChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={averageSentenceLengthClsOptions} 
              series={averageSentenceLengthClsSeries} 
              type="bar" 
              height={350} 
      />;      

    //******************************* averageSentenceLength (toks)
    let filteredAverageSentenceLength={};
    for (key in nbSents) {
      if (key !=='__global__') {
        filteredAverageSentenceLength[key]=rounded(size[key]/nbSents[key]);
      }
    }
    const [averageSentenceLengthOptions,averageSentenceLengthSeries]=this.computeChartOption(filteredAverageSentenceLength,t('averageSentLengthToks'));
    const averageSentenceLengthChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={averageSentenceLengthOptions} 
              series={averageSentenceLengthSeries} 
              type="bar" 
              height={350} 
      />;

    //******************************* averageClauseLength
    let filteredAverageClauseLength={};
    for (key in nbSents) {
      if (key !=='__global__' && nbCls && nbCls[key]!==0) {
        filteredAverageClauseLength[key]=rounded(size[key]/nbCls[key],2);
      }
    }
    const [averageClauseLengthOptions,averageClauseLengthSeries]=this.computeChartOption(filteredAverageClauseLength,t('averageClauseLengthToks'));
    const averageClauseLengthChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={averageClauseLengthOptions} 
              series={averageClauseLengthSeries} 
              type="bar" 
              height={350} 
      />;
    

    //******************************* lexicalDensity
    const [lexicalDensityOptions,lexicalDensitySeries]=this.computeChartOption(lexicalDensity,t('lexicalDensity'));
    const lexicalDensityChart= 
      <Chart  colors={['#F44336', '#E91E63', '#9C27B0']} 
              options={lexicalDensityOptions} 
              series={lexicalDensitySeries} 
              type="bar" 
              height={350} 
      />;

    return(
       <>
        <Paper className="margin-bottom-1-rem padding-1-rem">
            <div style={{
              display:"flex",
              flexWrap:"wrap", 
              flexDirection:"row",
              alignItems: "center"
              }}>

              <div id="nbDocsChart" className="column">
                  <H4>{t('docNumberColon')}</H4>
                  {nbDocsChart}
              </div>

              <div id="nbParasChart" className="column">
                  <H4>{t('paraNumberColon')}</H4>
                  {nbParasChart}
              </div>

              <div id="nbSentsChart" className="column">
                  <H4>{t('sentNumberColon')}</H4>
                  {nbSentsChart}
              </div>

              <div id="nbClsChart" className="column">
                  <H4>{t('clsNumberColon')}</H4>
                  {nbClsChart}
              </div>

              <div id="nbToksChart" className="column">
                  <H4>{t('tokenNumberColon')}</H4>
                  {nbToksChart}
              </div>              

              <div id="vocSizeChart" className="column">
                  <H4>{t('vocSizeColon')}</H4>
                  {vocSizeChart}
              </div>

              <div id="typeTokenChart" className="column">
                  <H4>{t('TTRColon')}</H4>
                  {typeTokenChart}
              </div>


              <div id="averageWordLengthChart" className="column">
                  <H4>{t('averageWordLengthColon')}</H4>
                  {averageWordLengthChart}
              </div>

              <div id="averageParagraphLengthChart" className="column">
                  <H4>{t('averageParaLengthToksColon')}</H4>
                  {averageParagraphLengthChart}
              </div>              
              
              <div id="averageSentenceLengthClsChart" className="column">
                  <H4>{t('averageSentLengthClsColon')}</H4>
                  {averageSentenceLengthClsChart}
              </div>

              <div id="averageSentenceLengthChart" className="column">
                  <H4>{t('averageSentLengthToksColon')}</H4>
                  {averageSentenceLengthChart}
              </div>

              <div id="averageClauseLengthChart" className="column">
                  <H4>{t('averageClauseLengthToksColon')}</H4>
                  {averageClauseLengthChart}
              </div>

              <div id="lexicalDensityChart" className="column">
                <H4>{t('lexicalDensityColon')}</H4>
                {lexicalDensityChart}
              </div>
            </div>
        </Paper>
       </>
    );
  }
}

VocComparison.propTypes = {
    size:PropTypes.object,
    nbSents:PropTypes.object,
    nbDocs:PropTypes.object,
    nbParas:PropTypes.object,
    nbCls:PropTypes.object,
    vocSize:PropTypes.object,
    lexicalDensity:PropTypes.object,
    averageLength:PropTypes.object,
};

export default withTranslation()(VocComparison);
